<div class="contact-us-wrapper">
  <app-header [header-data]="headerData"></app-header>

  <div class="container px-0">
    <div class="creditor-portal">
      <div class="row mt-4 mb-5">
        <div class="col-12 col-md-5">
          <!-- <p>How can we help you???</p> -->
          <mat-form-field class="is-invalid" [floatLabel]="'never'">
            <mat-label>Select</mat-label>
            <mat-select class="form-control" [(ngModel)]="category" [ngModelOptions]="{standalone: true}"
              (selectionChange)="changeFAQCategory()">
              <mat-option value=null selected>Select</mat-option>
              <mat-option *ngFor="let value of faqCategories" [value]="value.faqCategoryId">
                {{value.categoryName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row hght100">
        <div class="col-md-12 hght100" *ngFor="let element of initialFAQQuestionAnswerList">
          <div class="faq-sec">
            <h3>{{element.question}}</h3>
            <!-- <div [innerHTML]="element.answer"></div> -->
              <div class="textarea-wrapper my-5">
                  <div class="sd-textarea">
                    <ckeditor class="ckbackground ck-custom-content" tagName="textarea"  [disabled]="true" [(ngModel)]="element.answer" [config]="config" [editor]="Editor" class="text-editor"></ckeditor>
                  </div>
              </div>
            
            <div class="row customFileSection">
              <div class="customFileName" *ngFor="let document of element?.faqQuestionAndAnswerSupportingDocuments" (click)='onClickToDownloadFile(document.filePath,document.originalFileName)'>
                <a href="javascript:;" class="after-upload-link">
                  
                  <span
                      [matTooltip]="document.originalFileName"
                      aria-label="Button that displays a tooltip when focused or hovered over"
                      matTooltipPosition="right">
                      <mat-icon class="file-ic">description</mat-icon>
                  </span>
                  
              </a>
              {{document.originalFileName}}
              </div>
              <div class="d-flex justify-content-end">
                <button class="primary-button download bg-transparent" *ngIf="element?.faqQuestionAndAnswerSupportingDocuments.length > 1" (click)="downloadAllFiles(element?.faqQuestionAndAnswerSupportingDocuments)">
                  <img src="./../../../../assets/images/creditor-portal/download.svg" alt="Download">
                  DOWNLOAD ALL</button>
            </div>
            </div>

          </div>

        </div>
      </div>
      <div class="d-flex justify-content-center mt-3 mb-5"
        *ngIf="initialFAQQuestionAnswerList.length!=0 && faqQuestionAnswerList.length >5">
        <a *ngIf="!isLoadMoreClicked" href="javascript:" class="load-more-link" (click)="onClickLoadMore()">Load
          More</a>
      </div>
    </div>
  </div>

</div>